import { ArticleHeading2, ArticleParagraph1 } from '@cian/ui-kit';

import { FC } from 'react';

import { ShowCoworkingOperatorPhoneButton } from '../ShowCoworkingOperatorPhoneButton';
import { IconGlass } from '../UI/Icons';

import * as styles from './styles.css';

export const LearnMore: FC = () => {
  return (
    <div className={styles['root']}>
      <div className={styles['title']}>
        <IconGlass className={styles['icon']} />
        <ArticleHeading2 as="span">Хотите узнать больше?</ArticleHeading2>
      </div>
      <div className={styles['description']}>
        <ArticleParagraph1 as="span" color="black_100" fontWeight="normal">
          Наиболее полная информация находится у оператора коворкинга.
        </ArticleParagraph1>
      </div>
      <div className={styles['contacts']}>
        <ShowCoworkingOperatorPhoneButton />
      </div>
    </div>
  );
};

LearnMore.displayName = 'LearnMore';
